@if (!refreshMap) {
  <google-map width="100%" [options]="mapOptions" [height]="passedHeight ?? 750">
    @for (marker of markers; track $index; let i = $index) {
      <map-advanced-marker #thisMarker="mapAdvancedMarker" 
        [position]="marker.position" [label]="marker.label" [title]="marker.title"
        [gmpDraggable]="marker.draggable" [content]="marker.icon"
        (mapClick)="openInfoWindow(thisMarker, i, marker.info)">
        <map-info-window>
          <div class="text-center p-2">
              <a href="javascript:void(0);" (click)="openInfo(marker.info)" style="font-size: large;">
                  {{ marker.title }}
              </a>

              <hr class="mb-3 mt-2">

              @if (marker.free && marker.occupied) {
                <div class="d-flex flex-row justify-content-center">
                    <div class="d-inline-flex d-row align-items-center">
                        <span class="cerchio mr-2" [ngStyle]="{'background-color': '#349b34'}"></span>
                        <span class="darkText mr-2">{{ marker.free }}</span>
                    </div>
                    <div class="d-inline-flex d-row align-items-center">
                        <span class="cerchio mr-2" [ngStyle]="{'background-color': '#bb2d2d'}"></span>
                        <span class="darkText mr-2">{{ marker.occupied }}</span>
                    </div>
                </div>
              }
          </div>

          @if (marker.groups?.length) {
            <div class="darkText text-center p-2">
                <div class="d-flex flex-column justify-content-center">
                  @for (group of marker.groups; track $index) {
                    <div class="d-inline-flex d-row align-items-center">
                        <div class="cerchio mr-2" [ngStyle]="{'background-color': '#' + group.Color}"
                            (click)="openDeviceGroupDetail(group.Id)"></div>
                        <a href="javascript:void(0);" class="mr-2"
                            (click)="openDeviceGroupDetail(group.Id)">{{ group.Name }}</a>
                    </div>
                  }
                </div>
            </div>
          }
        </map-info-window>
      </map-advanced-marker>
    }

    @for (polyline of this.polylines; track $index) {
      <map-polyline [path]="polyline.path" [options]="polyline.options"></map-polyline>
    }
  </google-map>
}
@else {
  <div class="w-100" [ngStyle]="{'height': (passedHeight ? passedHeight : 750) + 'px'}"></div>
}
